import { Formik } from 'formik';
import React from 'react';
import Form from '../../common/Form';
import HelperText from '../../../mdc/HelperText';
import { uppercaseFirstLetter } from '../../../util/string';
import ProfilePictureUpload from '../ProfilePictureUpload';
import * as Yup from 'yup';
import { IonButton } from '@ionic/react';

interface ProfilePictureFormProps {
  photoURL: string;
  onSubmit: (values: { photoFile: File | null }) => void;
}

const ProfilePictureForm: React.FC<ProfilePictureFormProps> = ({
  photoURL,
  onSubmit,
}) => {
  return (
    <Formik
      initialValues={{
        photoFile: null,
      }}
      onSubmit={async (values, helpers) => {
        await onSubmit(values);
        helpers.resetForm();
      }}
      validateOnMount
      validationSchema={Yup.object({
        photoFile: Yup.object().nullable(),
      })}
    >
      {({
        setFieldValue,
        isValid,
        errors,
        touched,
        isSubmitting,
        setFieldTouched,
      }) => (
        <Form>
          <ProfilePictureUpload
            photoURL={photoURL || null}
            name="photoURL"
            onChange={(file) => {
              setFieldValue('photoFile', file);
              setFieldTouched('photoFile', true);
            }}
          />
          {touched.photoFile && errors.photoFile && (
            <HelperText>{uppercaseFirstLetter(errors.photoFile)}</HelperText>
          )}
          {touched.photoFile && (
            <IonButton type="submit" disabled={isSubmitting} expand="block">
              Save
            </IonButton>
          )}
        </Form>
      )}
    </Formik>
  );
};

export default ProfilePictureForm;
